(function () {
  var PORTAL_ROOT_ID = 'ghost-portal-root';
  var ACCENT = '#b3f25b';
  var ACCENT_INK = '#12210a';
  var BG = '#0b0a10';
  var SURFACE = '#15131c';
  var SURFACE_HI = '#1d1a28';
  var TEXT = '#ebe7f4';
  var TEXT_MUTED = '#7a7590';
  var BORDER = '#241f31';

  function isDark() {
    return document.body.classList.contains('theme-dark');
  }

  function buildPopupCSS() {
    return [
      '.gh-portal-popup-wrapper { background: rgba(0,0,0,0.8) !important; }',
      '.gh-portal-popup-container { background: ' + SURFACE + ' !important; color: ' + TEXT + ' !important; border: 1px solid ' + BORDER + ' !important; }',
      '.gh-portal-main-title, .gh-portal-text, .gh-portal-section-title { color: ' + TEXT + ' !important; }',
      '.gh-portal-input { background: ' + BG + ' !important; color: ' + TEXT + ' !important; border-color: ' + BORDER + ' !important; }',
      '.gh-portal-input::placeholder { color: ' + TEXT_MUTED + ' !important; }',
      // Catch-all: any Ghost-Portal button picks up accent unless explicitly secondary/text
      'button[class*="gh-portal-btn"]:not([class*="secondary"]):not([class*="text"]):not([class*="link"]):not([class*="close"]) { background: ' + ACCENT + ' !important; color: ' + ACCENT_INK + ' !important; border-color: ' + ACCENT + ' !important; }',
      'button[class*="gh-portal-btn"]:not([class*="secondary"]):not([class*="text"]):not([class*="link"]):not([class*="close"]) * { color: ' + ACCENT_INK + ' !important; }',
      '.gh-portal-btn-main, .gh-portal-btn-branded { background: ' + ACCENT + ' !important; color: ' + ACCENT_INK + ' !important; border-color: ' + ACCENT + ' !important; }',
      '.gh-portal-list-item, .gh-portal-plan-card { background: ' + SURFACE_HI + ' !important; border-color: ' + BORDER + ' !important; }',
      '.gh-portal-plan-name, .gh-portal-plan-price, .gh-portal-plan-description { color: ' + TEXT + ' !important; }',
      '.gh-portal-logout-button, .gh-portal-close-button { color: ' + TEXT_MUTED + ' !important; }',
      '.gh-portal-link { color: ' + ACCENT + ' !important; }',
      'hr, .gh-portal-divider { border-color: ' + BORDER + ' !important; }',
      // Recommendations screen: dark cards, themed buttons, hide entirely when empty
      '[class*="recommendation"] { background: ' + SURFACE_HI + ' !important; color: ' + TEXT + ' !important; border-color: ' + BORDER + ' !important; }',
      '[class*="recommendation"] button { background: ' + ACCENT + ' !important; color: ' + ACCENT_INK + ' !important; border: 1px solid ' + ACCENT + ' !important; }',
      '[class*="recommendation"] a, [class*="recommendation"] h1, [class*="recommendation"] h2, [class*="recommendation"] h3, [class*="recommendation"] p, [class*="recommendation"] span { color: ' + TEXT + ' !important; }'
    ].join('\n');
  }

  function injectIntoIframe(iframe) {
    try {
      var doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
      if (!doc || !doc.head) return;
      var existing = doc.getElementById('disane-portal-theme');
      if (existing) existing.parentNode.removeChild(existing);
      var style = doc.createElement('style');
      style.id = 'disane-portal-theme';

      var title = (iframe.getAttribute('title') || '').toLowerCase();
      if (title.indexOf('trigger') !== -1) return; // trigger button is hidden via CSS; nothing to style
      var css = isDark() ? buildPopupCSS() : '';
      if (!css) return;
      style.textContent = css;
      doc.head.appendChild(style);
    } catch (e) {
      // Cross-origin guard — fails silently if portal becomes cross-origin
    }
  }

  function handleIframe(iframe) {
    if (iframe.__disanePortalBound) {
      injectIntoIframe(iframe);
      return;
    }
    iframe.__disanePortalBound = true;
    var ready = iframe.contentDocument && iframe.contentDocument.readyState === 'complete';
    if (ready) injectIntoIframe(iframe);
    iframe.addEventListener('load', function () {
      injectIntoIframe(iframe);
    });
  }

  function scanRoot(root) {
    var iframes = root.querySelectorAll('iframe');
    for (var i = 0; i < iframes.length; i++) handleIframe(iframes[i]);
  }

  function watchRoot(root) {
    scanRoot(root);
    var inner = new MutationObserver(function () {
      scanRoot(root);
    });
    inner.observe(root, { childList: true, subtree: true });
  }

  function init() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1 && node.id === PORTAL_ROOT_ID) {
            watchRoot(node);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: false });

    var existing = document.getElementById(PORTAL_ROOT_ID);
    if (existing) watchRoot(existing);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
